function NotFoundPage() {
  return <p>not found</p>;
}

export default NotFoundPage;
